import type { AxiosInstance } from 'axios';
import type {
  CreateMessageGenSessionRequest,
  MessageGenSession,
  MessageGenSessionEventRequest,
  MarketingMessage,
} from '../types/message-generation.js';

export class MessageGenerationClient {
  constructor(private authenticatedClient: AxiosInstance) {}

  createSession = async (data: CreateMessageGenSessionRequest): Promise<MessageGenSession> => {
    const res = await this.authenticatedClient.post<MessageGenSession>('/message-gen-sessions', data);
    return res.data;
  };

  getSession = async (sessionId: string): Promise<MessageGenSession> => {
    const res = await this.authenticatedClient.get<MessageGenSession>(`/message-gen-sessions/${sessionId}`);
    return res.data;
  };

  sendEvent = async (data: MessageGenSessionEventRequest): Promise<void> => {
    await this.authenticatedClient.post('/message-gen-sessions/events', data);
  };

  startSession = async (
    config: {
      segmentIdentifier?: string;
      segmentationSessionId?: string;
      count: number;
      category: string;
      targetAudience: string;
    }
  ): Promise<{ sessionId: string; chatInstanceId: string }> => {
    const res = await this.authenticatedClient.post<{ sessionId: string; chatInstanceId: string }>(
      '/message-gen-sessions/start',
      { config }
    );
    return res.data;
  };

  listMessages = async (sessionId: string): Promise<MarketingMessage[]> => {
    const res = await this.authenticatedClient.get<MarketingMessage[]>(`/message-gen-sessions/${sessionId}/messages`);
    return res.data;
  };

  updateMessage = async (
    sessionId: string,
    messageIndex: number,
    updates: Partial<MarketingMessage>
  ): Promise<MarketingMessage> => {
    const res = await this.authenticatedClient.patch<MarketingMessage>(
      `/message-gen-sessions/${sessionId}/messages/${messageIndex}`,
      updates
    );
    return res.data;
  };
}
